import React from "react";
import { motion } from "framer-motion";

export default function Loader({ label = "Loading" }) {
  return (
    <div className="pm-loader">
      <motion.div
        className="pm-loader__ring"
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 0.9, ease: "linear" }}
      />
      <span>{label}</span>
    </div>
  );
}
